// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UScK","title":"styles_title__XXuOV"};